<template>
	<ListSelector
		class="pt-4"
		:items="toolPlacements"
		:selectedItemId="localValue"
		@selectItem="selectToolPlacement"
		allow-keyboard-navigation
		v-bind="$attrs"
		v-on="$listeners"
	>
		<template #item-content="{ item }">
			<ToolPlacementRow :tool="item" />
		</template>
		<template #tooltip="{ item }">
			<ExtensionNeededTooltip v-if="item.extensionNeeded" />
		</template>
	</ListSelector>
</template>

<script>
import VModelMixin from '@/mixins/VModelMixin';
import ListSelector from '@/components/common/ListSelector';
import ExtensionNeededTooltip from '../common/ExtensionNeededTooltip.vue';
import ToolPlacementRow from './ToolPlacementRow.vue';
import { TOOL_PLACEMENTS } from './ChooseToolPlacement.const';
import { isFeatureOn } from '@/store/modules/featureFlags/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
export default {
	name: 'ToolPlacementSelector',
	mixins: [VModelMixin],
	components: { ListSelector, ExtensionNeededTooltip, ToolPlacementRow },
	computed: {
		...mapGettersShorthand({ isFeatureOn }),
		toolPlacements() {
			const placements = Object.values(TOOL_PLACEMENTS);
			return placements.filter((placement) => !placement.conditionalFlag || this.isFeatureOn(placement.conditionalFlag));
		},
	},
	methods: {
		selectToolPlacement(toolPlacementId) {
			this.localValue = toolPlacementId;
			this.$emit('click', toolPlacementId);
		},
	},
};
</script>

<style lang="scss" scoped></style>
